module.exports = "<div>\n  <transition name=\"fadeModal\">\n    <div class=\"adminUi-modalOverlay\" v-if=\"modal\" @click.prevent=\"$emit('close-modal')\">\n      <div class=\"adminUi-modalCloseRow\">\n        <a class=\"adminUi-modalCloseLink\"></a>\n      </div>\n      <div\n        class=\"drzStorm-modal-content\"\n        @click.stop\n        :style=\"{ width: modal === 'my-profile' ? '50%' : null }\">\n        <component :is=\"pages[modal]\" />\n      </div>\n    </div>\n  </transition>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/storm/pages/settings-modal/template.html
// module id = iRIP
// module chunks = 0